
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Group 49120","xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15.002"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 33770","d":"M13.552 7.286V3.678a2.1 2.1 0 00-2.085-2.1h-.521V.525a.521.521 0 10-1.042 0v1.051H3.649V.525a.521.521 0 10-1.042 0v1.051h-.521a2.1 2.1 0 00-2.085 2.1v7.881a2.1 2.1 0 002.085 2.1h5.365a4.367 4.367 0 003.148 1.342 4.437 4.437 0 002.954-7.716M2.085 12.609a1.048 1.048 0 01-1.042-1.051V6.305A1.048 1.048 0 012.085 5.25h9.382a1.048 1.048 0 011.042 1.051v.271a4.338 4.338 0 00-1.911-.446 4.436 4.436 0 00-3.9 6.48z","fill":"#8d96a2"}}),_c('path',{attrs:{"data-name":"Path 33771","d":"M12.418 11.159l-1.265-.8V8.303a.551.551 0 10-1.1 0v2.358a.553.553 0 00.257.466l1.521.964a.552.552 0 00.59-.932","fill":"#fff"}})])
          )
        }
      }
    